import React from "react";
import {objectTypes} from "../../buttonpanel/interface/Ibuttons";

// import {soundAssetConfig} from "../../../data/sounds";


interface IframeworkLayouts {
    data: {}
}

export const frameworkLayouts: IframeworkLayouts = {
    data: {
        layouts: [
            // {

            //     "name": "btn_spin",
            //     "screenMode": "Portrait",
            //     "handMode": "right",
            //     "uiMode": "mobile",
            //     "x": 824,
            //     "y": 900,

            // },
            // {

            //     "name": "btn_spin",
            //     "screenMode": "Landscape",
            //     "handMode": "right",
            //     "x": 1124,
            //     "y": 522,

            // }
        ]
    }

};
export const layoutsConfigurationContext = React.createContext(
    {}
);